import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(undefined); // undefined = checking, null = guest, {} = signed in
  const [ready, setReady] = useState(false);

  const check = useCallback(async () => {
    // We cannot detect the session locally because the auth cookie is
    // HttpOnly (invisible to JS). Always ask the backend — /customer/me
    // returns 401 for guests, which we treat as "not signed in".
    try {
      const { data } = await api.get("/customer/me");
      setCustomer(data);
    } catch {
      setCustomer(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    // If we're returning from Emergent OAuth, AuthCallback will exchange the
    // session_id first — skip the /me check to avoid a 401 race.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setCustomer(null);
      setReady(false);
      return;
    }
    check();
  }, [check]);

  const signInWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/customer/logout"); } catch {}
    setCustomer(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, ready, signInWithGoogle, logout, refresh: check, setCustomer, setReady }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomer = () => useContext(CustomerAuthContext);
